/* eslint-disable no-console */
import { ApolloClient } from 'apollo-client';
import {
  InMemoryCache,
  IntrospectionFragmentMatcher,
} from 'apollo-cache-inmemory';
import { BatchHttpLink } from 'apollo-link-batch-http';
import {
  fragmentCacheRedirect,
  fragmentLinkState,
} from 'apollo-link-state-fragment';
import { onError } from 'apollo-link-error';
import { ApolloLink, Observable } from 'apollo-link';
import { createBrowserHistory } from 'history';
import { adminApiUrl, apiUrl, localStorageAuthKey } from 'config';
// our routes
import { USER } from 'routes/paths';

import introspectionQueryResultData from 'fragmentTypes.json';

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData,
});

export const history = createBrowserHistory();

const cache = new InMemoryCache({
  fragmentMatcher,
  cacheRedirects: {
    Query: {
      ...fragmentCacheRedirect(),
    },
  },
});

const request = operation => {
  const token = localStorage.getItem(localStorageAuthKey);
  operation.setContext({
    headers: {
      authorization: token ? `JWT ${token}` : '',
    },
  });
};

const requestLink = new ApolloLink(
  (operation, forward) =>
    new Observable(observer => {
      let handle;
      Promise.resolve(operation)
        .then(oper => request(oper))
        .then(() => {
          handle = forward(operation).subscribe({
            next: observer.next.bind(observer),
            error: observer.error.bind(observer),
            complete: observer.complete.bind(observer),
          });
        })
        .catch(observer.error.bind(observer));

      return () => {
        if (handle) handle.unsubscribe();
      };
    }),
);

export const apiClient = new ApolloClient({
  link: new BatchHttpLink({
    uri: apiUrl,
  }),
  cache,
});

export default new ApolloClient({
  link: ApolloLink.from([
    onError(({ networkError, operation }) => {
      if (networkError) {
        const { response } = operation.getContext();

        // if server is offline
        if (!response) {
          console.log('Server Offline');
        }
        if (response.status === 403) {
          history.push(USER.LOGIN);
        }
        console.log(`[Network error]: ${networkError}`);
      }
    }),
    requestLink,
    fragmentLinkState(cache),
    new BatchHttpLink({
      uri: adminApiUrl,
      credentials: 'include',
    }),
  ]),
  cache,
});
